/* eslint-disable no-unused-vars */
import { Box, Typography } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import { useVCControl } from './VCHooks';

const Participant = ({ participant, isLocal }) => {
  const [videoTracks, setVideoTracks] = useState([]);
  const [audioTracks, setAudioTracks] = useState([]);

  const { VCControlState } = useVCControl();

  const videoRef = useRef();
  const audioRef = useRef();

  const trackpubsToTracks = (trackMap) =>
    Array.from(trackMap.values())
      .map((publication) => publication.track)
      .filter((track) => track !== null);

  useEffect(() => {
    setVideoTracks(trackpubsToTracks(participant.videoTracks));
    setAudioTracks(trackpubsToTracks(participant.audioTracks));

    const trackSubscribed = (track) => {
      if (track.kind === 'video') {
        setVideoTracks((videoTracks) => [...videoTracks, track]);
      } else if (track.kind === 'audio') {
        setAudioTracks((audioTracks) => [...audioTracks, track]);
      }
    };

    const trackUnsubscribed = (track) => {
      if (track.kind === 'video') {
        setVideoTracks((videoTracks) => videoTracks.filter((v) => v !== track));
      } else if (track.kind === 'audio') {
        setAudioTracks((audioTracks) => audioTracks.filter((a) => a !== track));
      }
    };

    participant.on('trackSubscribed', trackSubscribed);
    participant.on('trackUnsubscribed', trackUnsubscribed);

    return () => {
      setVideoTracks([]);
      setAudioTracks([]);
      participant.removeAllListeners();
    };
  }, [participant]);

  useEffect(() => {
    const videoTrack = videoTracks[0];
    if (videoTrack) {
      videoTrack.attach(videoRef.current);
      return () => {
        videoTrack.detach();
      };
    }
  }, [videoTracks]);

  useEffect(() => {
    const audioTrack = audioTracks[0];
    if (audioTrack) {
      audioTrack.attach(audioRef.current);
      return () => {
        audioTrack.detach();
      };
    }
  }, [audioTracks]);

  useEffect(() => {
    // Switch the audio output device when activeAudioOutputId is updated
    audioRef.current?.setSinkId?.(VCControlState.activeAudioOutputId);  // Switch audio output once device id changed
  }, [VCControlState.activeAudioOutputId]);

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: '100%',
      }}
    >
      <video ref={videoRef} autoPlay={true} width="100%" height="100%" style={{transform: isLocal ? 'scaleX(-1)':''}}/>
      <audio ref={audioRef} autoPlay={true} />
      <Box
        sx={{
          display: 'flex',
          position: 'absolute',
          left: 0,
          top: 0,
          m: '15px',
        }}
      >
        <Typography
          variant="body1"
          color="white"
        >
          {isLocal ? `${participant.identity} (You)` : participant.identity}
        </Typography>
      </Box>
    </Box>
  );
};

const videoStyle = {

}
export default Participant;
